import type { IFilter } from '@models/Filter'
import { endOfDay, startOfDay } from '@util/date-util'

import { apiClient } from '../../../gateways/api'
import type { ActiviteitenSearch } from '../types/ActiviteitenSearch'

export { initialState, createFilters, searchActiviteiten }

const AANSLUITING_PROJECT_TYPES = ['Aanvraag']

const initialState: ActiviteitenSearch = {
  data: { count: 0, skip: 0, limit: 25, items: [] },
  query: {
    filters: {
      gebied: [],
      type: [],
      assignedTo: [],
      fromChangedDate: null,
      toChangedDate: null,
      fromDate: null,
      toDate: null,
      fromGeplandeUitvoeringsdatum: null,
      toGeplandeUitvoeringsdatum: null,
      labels: [],
      myList: false,
      kpi: '',
    },
    sort: { sortBy: 'created.date', sortDirection: 'desc' },
    page: { skip: 0, limit: 25 },
  },
}

const createFilters = ({
  gebied,
  type,
  assignedTo,
  toDate,
  fromDate,
  toChangedDate,
  fromChangedDate,
  fromGeplandeUitvoeringsdatum,
  toGeplandeUitvoeringsdatum,
  labels,
  myList,
  kpi,
}) => {
  const filters: IFilter[] = [
    { name: 'status', value: 'open', operator: 'eq' },
    { name: 'isActive', value: true, operator: 'eq' },
    {
      name: 'entity.projecttype',
      value: AANSLUITING_PROJECT_TYPES,
      operator: 'in',
    },
  ]

  if (type && type.length > 0)
    filters.push({
      name: 'type',
      value: type.map(({ code }) => code),
      operator: 'in',
    })

  if (gebied && gebied.length > 0)
    filters.push({
      name: 'entity.gebiedscode',
      value: gebied.map(({ code }) => code),
      operator: 'in',
    })
  if (assignedTo && assignedTo.length > 0)
    filters.push({
      name: 'assignedTo',
      value: assignedTo.map(({ label }) => label),
      operator: 'in',
    })
  if (fromDate)
    filters.push({
      name: 'dueDate',
      value: startOfDay(fromDate),
      operator: 'gte',
    })
  if (toDate)
    filters.push({ name: 'dueDate', value: endOfDay(toDate), operator: 'lte' })
  if (fromChangedDate)
    filters.push({
      name: 'changed',
      value: startOfDay(fromChangedDate),
      operator: 'gte',
    })
  if (toChangedDate)
    filters.push({
      name: 'changed',
      value: endOfDay(toChangedDate),
      operator: 'lte',
    })
  if (fromGeplandeUitvoeringsdatum) {
    filters.push({
      name: 'geplandeUitvoeringsdatum',
      value: startOfDay(fromGeplandeUitvoeringsdatum),
      operator: 'gte',
    })
  }
  if (toGeplandeUitvoeringsdatum) {
    filters.push({
      name: 'geplandeUitvoeringsdatum',
      value: endOfDay(toGeplandeUitvoeringsdatum),
      operator: 'lte',
    })
  }
  if (labels && labels.length > 0)
    filters.push({
      name: 'labels',
      value: labels.map(({ code }) => code),
      operator: 'in',
    })

  if (myList) {
    filters.push({ name: 'my-list', value: true, operator: 'eq' })
  }

  if (kpi) {
    filters.push({ name: 'kpi', value: kpi, operator: 'eq' })
  }

  return filters
}

const searchActiviteiten = async ({
  query,
}: {
  query: ActiviteitenSearch['query']
}): Promise<ActiviteitenSearch['data']> => {
  const { filters, page, sort } = query

  const { data } = await apiClient({
    url: '/rest/activiteit/search',
    method: 'POST',
    data: { filters: createFilters(filters), ...page, ...sort },
  })

  return data
}
